document.addEventListener('alpine:init', () => {
    function QueryParameters() {
        return new URLSearchParams(window.location.search);
    }

    function GetQueryParameter(parameterName) {
        var parameter = QueryParameters().get(parameterName);
        return parameter == null ? '' : parameter;
    }

    function SetQueryParameter(parameterName, newValue) {
        var query = QueryParameters();
        query.set(parameterName, newValue);
        window.history.replaceState({}, '', `${location.pathname}?${query.toString()}`);
    }

    Alpine.data('appdata', () => ({
        globalsearchopen: false,
        globalsearchinputvalue: '',
        globalsearchtyping: false,
        globalsearchculture: '',
        getSearchCulturePrefix() {
            if (this.globalsearchculture == "en-GB") {
                return "";
            }
            else {
                return "/" + this.globalsearchculture;
            }
        },
        goToSearchPage(term) {
            const params = new URLSearchParams({
                searchTerm: term
            });

           // var searchCulture = this.getSearchCulturePrefix();

            window.location.href = this.globalsearchpageurl + "?" + params;
        },
        toggleGlobalSearch() {
            this.globalsearchopen = !this.globalsearchopen;

            // close main nav dropdown if it's open
            const mainNavDropdown = document.querySelector('.main-navigation-dropdown');
            mainNavDropdown.classList.remove('active');
            document.body.classList.remove('main-nav-open');
        },
        fetchResults() {

            if (this.globalsearchinputvalue == '') {
                this.globalsearchtyping = false;
                globalnewsearchbar.classList.remove('searching');
            }
            else {
                this.globalsearchtyping = true;
                globalnewsearchbar.classList.add('searching');

                const params = new URLSearchParams({
                    searchTerm: this.globalsearchinputvalue,
                    culture: this.globalsearchculture
                });

                $.get("/umbraco/surface/SearchSurface/TypeaheadSearch?" + params, function (data) {
                    $(typeaheadresults).html(data);
                }, 'text');
            }

        }
    }));

    Alpine.data('newsearch', () => ({
        onpagesearchcurrentpage: GetQueryParameter("page"),
        onpagesearchinputvalue: GetQueryParameter("searchTerm"),
        onpagesearchinsightsfilter: GetQueryParameter("insightsfilter"),
        onpagesearchexpertisefilter: GetQueryParameter("expertisefilter"),

        onpagesearchpersonservicefilter: GetQueryParameter("personservicefilter"),
        onpagesearchpersonsectorfilter: GetQueryParameter("personsectorfilter"),
        onpagesearchpersoncountryfilter: GetQueryParameter("personcountryfilter"),
        onpagesearchpersonofficefilter: GetQueryParameter("personofficefilter"),
        onpagesearchpersonlanguagefilter: GetQueryParameter("personlanguagefilter"),

        onpagesearchcareerroletypefilter: GetQueryParameter("careerroletypefilter"),
        onpagesearchcareerofficefilter: GetQueryParameter("careerofficefilter"),

        onpagesearchglobalpresenceregionfilter: GetQueryParameter("globalpresenceregionfilter"),
        onpagesearchglobalpresencecountryfilter: GetQueryParameter("globalpresencecountryfilter"),

        onpagesearchactiveprimaryfilter: '',
        resetSpecificFilter(localvariablename, querystringvariablename) {
            this[localvariablename] = "";
            SetQueryParameter(querystringvariablename, "");
		},
        resetSubFilters() {
            this.resetSpecificFilter("onpagesearchinsightsfilter", "insightsfilter");
            this.resetSpecificFilter("onpagesearchexpertisefilter", "expertisefilter");

         //   this.resetSpecificFilter("onpagesearchpersonservicefilter", "personservicefilter");
         //   this.resetSpecificFilter("onpagesearchpersonsectorfilter", "personsectorfilter");
         //   this.resetSpecificFilter("onpagesearchpersoncountryfilter", "personcountryfilter");
         //   this.resetSpecificFilter("onpagesearchpersonofficefilter", "personofficefilter");
         //   this.resetSpecificFilter("onpagesearchpersonlanguagefilter", "personlanguagefilter");

         //   this.resetSpecificFilter("onpagesearchcareerroletypefilter", "careerroletypefilter");
         //   this.resetSpecificFilter("onpagesearchcareerofficefilter", "careerofficefilter");
        },
        fetchPageResults(page) {

            const params = new URLSearchParams({
                searchTerm: this.onpagesearchinputvalue,
                culture: this.globalsearchculture,
                primaryfilter: this.onpagesearchactiveprimaryfilter,
                insightsfilter: this.onpagesearchinsightsfilter,
                expertisefilter: this.onpagesearchexpertisefilter,

                personservicefilter: this.onpagesearchpersonservicefilter,
                personsectorfilter: this.onpagesearchpersonsectorfilter,
                personcountryfilter: this.onpagesearchpersoncountryfilter,
                personofficefilter: this.onpagesearchpersonofficefilter,
                personlanguagefilter: this.onpagesearchpersonlanguagefilter,

                careerroletypefilter: this.onpagesearchcareerroletypefilter,
                careerofficefilter: this.onpagesearchcareerofficefilter,

                globalpresenceregionfilter: this.onpagesearchglobalpresenceregionfilter,
                globalpresencecountryfilter: this.onpagesearchglobalpresencecountryfilter,

                page: this.onpagesearchcurrentpage
            });

            $.get("/umbraco/surface/SearchSurface/GlobalSearch?" + params, function (data) {
                $(newsearchresults).html(data);
                searchpagetitle.scrollIntoView();
            }, 'text');
        },
        resetPage() {
            this.onpagesearchcurrentpage = 1;
            SetQueryParameter("page", 1);
        },
        changePage(pageNumber) {
            this.onpagesearchcurrentpage = pageNumber;
            SetQueryParameter("page", pageNumber);
            this.fetchPageResults(pageNumber);
        },
        setPrimaryFilter(id) {
            this.resetPage();

            this.resetSubFilters();

            this.onpagesearchactiveprimaryfilter = id;

            SetQueryParameter("primaryfilter", id);

            this.fetchPageResults(0);
        },
        setInsightsFilter(id) {
            this.resetPage();

            this.onpagesearchinsightsfilter = id;

            SetQueryParameter("insightsfilter", id);

            this.fetchPageResults(0);
        },
        setExpertiseFilter(id) {
            this.resetPage();

            this.onpagesearchexpertisefilter = id;

            SetQueryParameter("expertisefilter", id);

            this.fetchPageResults(0);
        },
        setSubFilter(id, localvariablename, querystringvariablename) {
            this.resetPage();

            this[localvariablename] = id;
            SetQueryParameter(querystringvariablename, id);

            this.fetchPageResults(0);
		},
        init() {
            this.onpagesearchactiveprimaryfilter = GetQueryParameter("primaryfilter");
            this.fetchPageResults(0);

        }
       
    }));
});
